import { Badge, FormSection, Radio } from '@ksyos/design-system';
import { RadioGroupFormGroup, TextAreaFormGroup } from '../../processActivityFormGroupFields';
import { resumeMdoInterimAdviceWithColor } from './bariPreResumeMdoInterimUtils';

export function BariPreResumeMdoInterimEdit(): JSX.Element {
    return (
        <FormSection>
            <RadioGroupFormGroup
                fieldKey="hervatten"
                isRequired={true}
                label="Hervatten in zorgpad"
            >
                {resumeMdoInterimAdviceWithColor.map((item) => (
                    <Radio
                        key={item.value}
                        label={
                            <Badge
                                color={item.color}
                                text={item.value}
                            />
                        }
                        value={item.value}
                    />
                ))}
            </RadioGroupFormGroup>

            <TextAreaFormGroup
                fieldKey="toelichting"
                isRequired={true}
                label="Toelichting"
                placeholder="Typ je toelichting..."
            />
        </FormSection>
    );
}
